export default __webpack_public_path__ + "static/woman-meditating-56d59223583455cf07fc2aaaac969374.png";